/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Loading from './Loading/index'
import Locations from './Locations/index'
import NoAppointmentAvailable from './NoAppointmentAvailable/index'
import React from 'react'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Content({
  children,
  viewPath = "/App/Form/Data/ProvideData/Location/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Loading'
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'Loading'}>
<Loading
  viewPath={`${viewPath}/Loading`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Locations'}>
<Locations
  viewPath={`${viewPath}/Locations`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'NoAppointmentAvailable'}>
<NoAppointmentAvailable
  viewPath={`${viewPath}/NoAppointmentAvailable`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}